import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b0d2496c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "c-date-time-range"
};
var _hoisted_2 = {
  class: "dateTimeSelect flex align-center justify-between align-stretch"
};
var _hoisted_3 = {
  class: "flex flex-column justify-between flex-1"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "开始时间", -1);
});
var _hoisted_5 = {
  class: "flex-1"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "结束时间", -1);
});
var _hoisted_7 = {
  class: "flex-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_calendar = _resolveComponent("van-calendar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "dateTime flex align-center",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.dateClick('start');
    })
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.startTime), 1)]), _createElementVNode("div", {
    class: "dateTime flex align-center",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.dateClick('end');
    })
  }, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.endTime), 1)])]), _createElementVNode("div", {
    class: "btn flex align-center justify-center",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      return _ctx.confirm && _ctx.confirm.apply(_ctx, arguments);
    })
  }, " 确定 ")]), _createVNode(_component_van_calendar, {
    color: "#4372F6",
    show: _ctx.show,
    "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.show = $event;
    }),
    "default-date": _ctx.defaultTime,
    "max-date": _ctx.maxDate,
    "min-date": _ctx.minDate,
    "lazy-render": false,
    onConfirm: _ctx.confirmDate
  }, null, 8, ["show", "default-date", "max-date", "min-date", "onConfirm"])]);
}